module.exports = __webpack_public_path__ + "static/img/alzx.c161463.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/alzx.png
// module id = /tTU
// module chunks = 0